const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Your Trusted CCTV & Security Partner",
    content: "At Secure Vision, we prioritize your safety and peace of mind. With our advanced security systems and professional services, we ensure your property is well-protected 24/7.",
    points: [
        {
            id: 1,
            title: 'Professional Installation',
            progress: 98,
        },
        {
            id: 2,
            title: 'Advanced Technology',
            progress: 95,
        },
        {
            id: 3,
            title: 'Customized Solutions',
            progress: 92,
        },
        {
            id: 4,
            title: '24/7 Monitoring',
            progress: 99,
        },
    ]
};

export default whyChooseUs;